<template>
    <v-flex style="z-index: 0;">
        <v-text-field
                :label="label"
                :placeholder="placeholder"
                @click:append="onSearchClicked"
                @keyup="onKeyUp($event.keyCode)"
                append-icon="mdi-magnify"
                dense
                outlined
                @click:clear="onClickClear"
                hide-details
                clearable
                single-line
                :id="id"
                v-model="keyword"
                autocomplete="off"
        >
        </v-text-field>
    </v-flex>
</template>

<script>
    /**
     * 검색어를 입력할 수 있는 컴포넌트 입니다.
     * @param placeholder 입력값이 없을 때 노출되는 안내 문구 입니다.
     * @param reactivity 다음 행동에 반응하여 키워드를 이벤트로 전달합니다. ['input', 'enter']
     * @param reactivityInputDelay 이벤트 반응 타입 reactivity 가 'input'인 경우 마지막 입력에 대한 딜레이를 설정합니다. 기본값: 500. 'enter' 인 경우 이 값이 무시됩니다.
     */

import {KEY_CODE} from "@/constants/keycodes";

    export default {
        name: "SearchBar",
        props: {
            value: {
                type: String,
                default: ''
            },
            label: {
                type: String,
                default: 'input'
            },
            placeholder: {
                type: String,
                default: 'input keywords here.'
            },
            reactivity: {
                type: String,
                default: 'enter'
            },
            reactivityInputDelay: {
                type: Number,
                default: 500
            },
            id: {
                type: String,
                default: 'searchbar',
            },
            clearable: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                keyword: this.value,
                timeout: null,
            }
        },

        computed: {
            shouldNotifyByInput() {
                return this.reactivity === 'input';
            }
        },

        watch: {
            value(newValue, oldValue) {
                this.keyword = newValue;
            },
            keyword(newValue, oldValue) {
                // 입력에 대해서 반응해야 할 때 동작합니다.
                if (this.shouldNotifyByInput) this.notifyKeywordDelayed();
            }
        },

        methods: {
            onKeyUp(keyCode) {
                if (this.reactivity === "input") {
                    this.notifyKeyword()
                    switch (keyCode) {
                        case KEY_CODE.ENTER:
                            this.$emit("enter", !!this.keyword ? this.keyword.trim() : this.keyword); // 엔터키 이벤트 발생!
                            break;
                    }
                } else {
                    switch (keyCode) {
                        case KEY_CODE.ENTER:
                            this.notifyKeyword();
                            break;
                    }
                }
            },
            /**
             * Input 에 Enter 키 이벤트를 발생시킵니다.
             */
            onSearchClicked() {
                const ke = new KeyboardEvent("keyup", {
                    bubbles: true, cancelable: true, keyCode: 13
                });
                document.getElementById(this.id).dispatchEvent(ke);
            },
            onClickClear() {
                this.keyword = '';
                this.notifyKeyword();
            },
            notifyKeyword() {
                let trim = !!this.keyword ? this.keyword.trim() : this.keyword;
                this.$emit('input', trim);
                this.$emit('update:keyword', trim);
                clearTimeout(this.timeout);
            },
            notifyKeywordDelayed() {
                const delay = this.reactivityInputDelay > 0 ? this.reactivityInputDelay : 0;
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.notifyKeyword();
                }, delay);
            },
        },
        created() {
            // this.notifyKeyword();
        }
    }
</script>

<style scoped>
    >>> input:read-only, >>> input {
        background-color: transparent !important;
        border: 0 !important;
        text-align: left !important;
    }
</style>
